var backBtn = document.querySelector('#lastPagePwa');
    
backBtn.addEventListener("click", function(){ 
    history.back();
});


const allPwaNavItems = document.querySelectorAll('.pwa-nav-item');
const currentPage = window.location.href;

allPwaNavItems.forEach(async (navItem) => {
  let acceptedUrls = (navItem.dataset.active).split(',');
  acceptedUrls.forEach(async (acceptedUrl) => {
    if(currentPage.includes(acceptedUrl)) {
        navItem.classList.add('active-nav');
    }
  });
});
